module.exports = __webpack_public_path__ + "img/logo_main.9f23ee17.png";